import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {enumToView} from '@src/utils';
import {INTEGRAL_GOOD_TYPE, ORDER_SUB_TYPE_V} from '@src/constants';

class OrderListStore extends StoreExt {
    @observable loading: boolean = false
    @observable lock: boolean = false
    @observable orderList: any[] = []
    @observable orderDetail: any = {}
    @observable pageSize: number = 10 // 每页长度
    @observable current: number = 1 // 当前页
    @observable total?: number = 0 // 数据总量
    @observable orderInfo: any[] = []
    @observable payInfo: any[] = []
    @action
    setLock = (flag) => {
        this.lock = flag
    }
    @action
    setCurrent = () => {
        this.current += 1
    }
    @action
    reStoreCurrent = () => this.current = 1
    // 获取订单列表
    @action
    getOrderList = async (id: any) => {
        if (this.lock) {
            return
        }
        try {
            const param = {
                current: this.current,
                pageSize: this.pageSize
            }
            const res = await this.api.getOrderList(param)
            runInAction(() => {
                this.orderList = this.current === 1 ? res.list : [...this.orderList, ...res.list]
                this.total = res.total
                this.setLock(res.list.length < 10)
            })
        } catch (e) {
        }
    }

    // 获取订单详情
    @action
    getOrderDetail = async (id) => {
        runInAction(() => this.loading = true)
        try {
            const param = {orderId: id}
            const res = await this.api.getOrderDetail(param)
            const {
                goodsReleaseName,
                totalFee,
                nickName,
                orderSubType,
                iccid,
                orderId,
                createTime,
                paymentType,
                salePrice,
                cargoType,
                integralGoodType, integralValue, integralName
            } = res.laoOrderDto
            runInAction(() => {
                this.loading = false
                this.orderDetail = res
                this.orderInfo = [
                    {
                        title: '商品名称',
                        value: orderSubType === ORDER_SUB_TYPE_V.INTEGRAL_EXCHANGE ? integralName : goodsReleaseName
                    },
                    {
                        title: '商品类型',
                        value: orderSubType === ORDER_SUB_TYPE_V.INTEGRAL_EXCHANGE ? enumToView('INTEGRAL_GOOD_TYPE', integralGoodType) : '流量套餐'
                    },
                    {
                        title: '设备名称',
                        value: nickName
                    },
                    {
                        title: '订购方式',
                        value: enumToView('ORDER_SUB_TYPE', orderSubType)
                    },
                    {
                        title: 'SIM卡ICCID',
                        value: iccid
                    }
                ]
                let basePayInfo = [{
                    title: '订单编号',
                    value: orderId
                },
                    {
                        title: '订单时间',
                        value: createTime
                    },
                ]
                if ((orderSubType === '2' || orderSubType === '8' || orderSubType === '9') && totalFee > 0) {
                    if (paymentType === '1' || paymentType === '2') {
                        basePayInfo = [...basePayInfo, {
                            title: '支付方式',
                            value: paymentType === '1' ? '微信' : '支付宝'
                        },
                            {
                                title: '优惠金额',
                                value: `${Number(totalFee) === Number(salePrice) ? '暂无优惠' : (enumToView('CURRENCY', cargoType)) + ((Number(salePrice) - Number(totalFee)) / 100)}`
                            },
                            {
                                title: '支付金额',
                                value: `${enumToView('CURRENCY', cargoType)}${totalFee / 100}`
                            }
                        ]
                    } else {
                        basePayInfo = [...basePayInfo, {
                            title: '支付金额',
                            value: `${enumToView('CURRENCY', cargoType)}${totalFee / 100}`
                        }]
                    }
                }
                if (orderSubType === ORDER_SUB_TYPE_V.INTEGRAL_EXCHANGE) {
                    if (totalFee > 0) {
                        basePayInfo = [...basePayInfo,
                            {
                                title: '支付方式',
                                value: paymentType === '1' ? '微信' : '支付宝'
                            },
                            {
                                title: '支付金额',
                                value: `${enumToView('CURRENCY', cargoType)}${totalFee / 100}`
                            },
                            {
                                title: '消耗积分',
                                value: `${integralValue}积分`
                            }
                        ]
                    } else {
                        basePayInfo = [...basePayInfo,
                            {
                                title: '消耗积分',
                                value: `${integralValue}积分`
                            }
                        ]
                    }
                }
                this.payInfo = basePayInfo
            })
        } catch (e) {
            runInAction(() => this.loading = false)
        }
    }

    // 下拉刷新
    @action
    onDown = (id) => {
        runInAction(() => {
            this.current = 1
            this.getOrderList(id)
        })
    }

    // 上拉加载
    @action
    onUp = (id) => {
        runInAction(() => {
            if (this.current <= Math.ceil(this.total / this.pageSize)) {
                this.getOrderList(id)
            } else {
                this.$toast.info('没有更多订单了')
            }
        })
    }

}

const orderListStore = new OrderListStore()
export {
    orderListStore,
    OrderListStore
}
